
// --- CACHE & SECURITY UTILITIES ---

// v6.0: TTLs configurados para persistência indefinida (Indefinite Caching Strategy)
// Endereços e distâncias não mudam se o Hub permanecer no mesmo local.
export const TTL_GEO = 100 * 365 * 24 * 60 * 60 * 1000;    // 100 anos
export const TTL_MATRIX = 100 * 365 * 24 * 60 * 60 * 1000; // 100 anos
export const TTL_CONTEXT = 15 * 60 * 1000;                 // 15 minutos (Clima/Radar ainda expiram)

export const obfuscate = (str: string): string => {
    try {
        return btoa(encodeURIComponent(str));
    } catch (e) {
        return str;
    }
};

export const deobfuscate = (str: string): string => {
    try {
        return decodeURIComponent(atob(str));
    } catch (e) {
        return str; 
    }
};

export const getCache = (key: string, ttl: number) => {
    try {
        const item = localStorage.getItem(key);
        if (!item) return {};
        
        const decrypted = deobfuscate(item);
        const storedCache = JSON.parse(decrypted);
        const now = Date.now();
        const validCache: any = {};
        let needsPruning = false;

        Object.keys(storedCache).forEach(k => {
            const entry = storedCache[k];
            // Verifica validade temporal
            if (entry && typeof entry === 'object' && entry.timestamp && (now - entry.timestamp < ttl)) {
                validCache[k] = entry;
            } else {
                needsPruning = true;
            }
        });

        if (needsPruning) {
            localStorage.setItem(key, obfuscate(JSON.stringify(validCache)));
        }

        return validCache;
    } catch (e) {
        return {};
    }
};

export const setCacheEntry = (cacheKey: string, entryKey: string, data: any, ttl: number) => {
    try {
        const currentCache = getCache(cacheKey, ttl);
        currentCache[entryKey] = { data: data, timestamp: Date.now() };
        const str = JSON.stringify(currentCache);
        // Limite de segurança do LocalStorage (~5MB)
        if (str.length < 4500000) { 
            localStorage.setItem(cacheKey, obfuscate(str));
        }
    } catch (e) {}
};
